import React, { useEffect } from "react";
import { createStyles, Stepper, Theme } from "@material-ui/core";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useSwipeable } from "react-swipeable";

interface IProps {
  steps: { label: string; component: any }[];
  activeStep: number;
  setActiveStep: Function;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    background: {
      width: "100%",
      backgroundColor: theme.palette.background.default,
    },
    step: {
      cursor: "pointer",
    },
  })
);

const StepperComponent: React.FC<IProps> = ({ steps, activeStep, setActiveStep }: IProps) => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px");
  const handlers = useSwipeable({
    onSwipedLeft: () => steps.length - 1 !== activeStep && setActiveStep(activeStep + 1),
    onSwipedRight: () => activeStep !== 0 && setActiveStep(activeStep - 1),
  });

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [activeStep]);

  return (
    <Box {...handlers} style={{ minHeight: "70vh" }}>
      <Stepper
        style={{ padding: isMobile ? "24px 0" : "20px", marginTop: "-15px" }}
        className={classes.background}
        activeStep={activeStep}
        alternativeLabel
        onTouchMove={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onTouchMoveCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
      >
        {steps.map((step, index) => (
          <Step className={classes.step} key={step.label}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {steps.map((step, index) => (
        <Box
          key={index}
          style={{ display: index === activeStep ? "block" : "none" }}
          onTouchMove={(e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }}
          onTouchMoveCapture={(e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }}
        >
          {step.component}
        </Box>
      ))}
    </Box>
  );
};

export default StepperComponent;
